import styled, { css } from 'styled-components';

interface MovementProps {
  width: number;
}

interface PointProps {
  left: number;
  top: number;
  firstPoint: boolean;
  lastPoint: boolean;
  width: number;
}

export const Container = styled.div`
  background: linear-gradient(180deg, #faf4e4 0%, #f5f3ed 100%);
  border-radius: 18px;
  padding: 5% 2% 6% 6%;

  .fix {
    position: absolute;
    bottom: 28px;
    left: 0;
    z-index: 1;
    width: 100%;
  }

  .bar-opacity {
    width: 1233px;
  }

  .month {
    color: #4e4a44;

    font-family: 'Source Sans Pro';
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 15.5px;
  }

  .invisible-div {
    position: absolute;
    height: 483px;
    width: 100%;
    bottom: -80px;
    /* background-color: #00000033; */
  }

  .month-selected {
    color: #ffae52;
  }

  > span:nth-child(1) {
    position: absolute;
    left: 2.5%;
    bottom: 24%;
    color: #4e4a44;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  > span:nth-child(2) {
    position: absolute;
    left: 1.5%;
    bottom: 39%;
    color: #4e4a44;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  > span:nth-child(3) {
    position: absolute;
    left: 1.5%;
    bottom: 54%;
    color: #4e4a44;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  > span:nth-child(4) {
    position: absolute;
    left: 1.5%;
    top: 28%;
    color: #4e4a44;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  > span:nth-child(5) {
    position: absolute;
    left: 1.5%;
    top: 13%;
    color: #29bc81;

    text-align: center;
    font-family: 'Libre Baskerville';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.5px;
  }

  .graph {
    clip-path: inset(-50px -14px 11px -6px);
  }
`;

export const Movement = styled.div<MovementProps>`
  position: absolute;
  bottom: 28px;
  left: 0;
  z-index: 2;
  width: ${(props) => props.width}px;

  .bar {
    width: 1233px;
  }
`;

export const CirclePoint = styled.div<PointProps>`
  position: absolute;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;
  z-index: 3;
  width: ${(props) => props.width}px;
  display: flex;
  justify-content: center;

  .value-point {
    position: absolute;

    ${(props) => {
      if (props.lastPoint) {
        return css`
          top: -50px;
        `;
      }
      if (props.firstPoint) {
        return css`
          top: -60px;
        `;
      }
      return css`
        top: -60px;
      `;
    }}

    span:nth-child(1) {
      color: #000;
      font-family: 'Libre Baskerville';
      font-size: 34px;
      font-weight: 700;
      text-align: center;
      line-height: 39px;
    }

    span:nth-child(2) {
      color: #0b9071;
      font-family: 'Libre Baskerville';
      font-size: 10px;
      font-weight: 400;
      text-align: center;
    }
  }
`;
